<template>
  <a
    :class="buttonClass"
    :href="
      'mailto:?subject=' +
        subject +
        '&body=' +
        text +
        '%0D%0D A teljes tartalom a Folkrádió weboldalán érhető el:%0D ' +
        encodeURIComponent(url)
    "
    class=""
  >
    <img
      src="/img/mail_icon.svg"
      alt=""
    >
    <span v-if="buttonText">{{ buttonText }}</span>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },

  methods: {}
};
</script>
